import React from 'react';
import { PortableText } from '@portabletext/react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import '../../css/common/RichText.css';

const components = {
  block: {
    normal: ({ children }) => <p className="richtext-p">{children}</p>,
    h2: ({ children }) => <h2 className="richtext-h2">{children}</h2>,
    h3: ({ children }) => <h3 className="richtext-h3">{children}</h3>,
    large: ({ children }) => <p className="richtext-large">{children}</p>,
  },
  marks: {
    strong: ({ children }) => <strong>{children}</strong>,
    em: ({ children }) => <em>{children}</em>,
    underline: ({ children }) => <span className="richtext-underline">{children}</span>,
    link: ({ value, children }) => {
      const href = value?.href || '#';
      const external = href.startsWith('http');
      return (
        <a
          href={href}
          className={`richtext-link${external ? ' richtext-link-external' : ''}`}
          target={external ? '_blank' : undefined}
          rel={external ? 'noopener noreferrer' : undefined}
        >
          {children}
          {external && <FaExternalLinkAlt className="richtext-link-icon" aria-hidden="true" />}
        </a>
      );
    },
  },
  list: {
    bullet: ({ children }) => <ul className="richtext-ul">{children}</ul>,
    number: ({ children }) => <ol className="richtext-ol">{children}</ol>,
  },
  listItem: {
    bullet: ({ children }) => <li>{children}</li>,
    number: ({ children }) => <li>{children}</li>,
  },
};

/**
 * Renders Sanity blockContent (bold, italic, underline, links, lists, headings).
 */
const PortableTextContent = ({ value, className = '' }) => {
  if (!value?.length) return null;
  return (
    <div className={`richtext-content ${className}`.trim()}>
      <PortableText value={value} components={components} />
    </div>
  );
};

export default PortableTextContent;
